import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { BookLink } from 'legacy/containers/LoadsPage/BookDialog/BookLink'
import { LOAD_BOARD_ACTIONS, useLoadboardContext } from 'legacy/contexts/loadBoard'

import { type BookingOffer } from '../../domain/LoadOffer'

export function useBookingOffer() {
  const [, dispatch] = useLoadboardContext()
  const { pathname: locationPathname, search: locationSearch } = useLocation()
  const history = useHistory()

  const navigateToBookOffer = useCallback(
    (bookingOffer: BookingOffer) => {
      dispatch({
        type: LOAD_BOARD_ACTIONS.BOOK_OFFER,
        payload: bookingOffer,
      })
      history.push(
        BookLink.getPath(
          locationPathname,
          locationSearch,
          bookingOffer.id,
          undefined,
          bookingOffer.bookingType
        )
      )
    },
    [dispatch, history, locationPathname, locationSearch]
  )

  return {
    navigateToBookOffer,
  }
}
